import type { VaultApyRange } from '@/types/apy'
import type { Vault } from '@/types/vault'
import type { VaultsSortSchema } from '@/types/vaultsSortSchema'
import { sortObjectsByKey } from '@vaultsfyi/common/utils'
import { getApyTypeKey } from '../apy'

export function sortVaults(
  vaults: Vault[],
  apyRange: VaultApyRange,
  includeRewards: boolean,
  { sortBy, asc }: VaultsSortSchema
) {
  const apySortKey = getApyTypeKey({ includeRewards })

  switch (sortBy) {
    case 'token':
      return sortObjectsByKey(vaults, ['asset', 'symbol'], asc, (symbol) => String(symbol)?.toLowerCase())
    case 'protocol':
      return sortObjectsByKey(vaults, ['protocol', 'name'], asc)
    case 'name':
      return sortObjectsByKey(vaults, ['name'], asc, (name) => name?.toLowerCase())
    case 'holders':
      return sortObjectsByKey(vaults, ['holdersData', 'totalCount'], asc)
    case 'apy':
      return sortObjectsByKey(vaults, ['apy', apyRange, apySortKey], asc, (value, vault) =>
        vault.apyComposite ? vault.apyComposite.totalApy[apyRange][apySortKey] : (value as number)
      )
    case 'score':
      return sortObjectsByKey(vaults, ['score'], asc, (_, vault) => vault.score?.vaultScore)
    case 'tvl':
    default:
      return sortObjectsByKey(vaults, ['tvl', 'usd'], asc, (tvl) => BigInt((tvl ?? '0') as string))
  }
}
